<template>
    <div :class="cssClass" @click.capture="editMode"  v-click-outside="viewMode">
        <span class="cms-option-button" v-on:click="destroy" v-if="mode == 'edit'">
            <span><i class="fa fa-trash"></i></span>
            {{ $t('delete') }}
        </span>
        <span class="cms-option-button move-handle" v-if="mode == 'edit'">
            <span class="arrow_move"></span>
            {{ $t('move') }}
        </span>

        <!--
        <span class="icon-close" v-on:click.capture="viewMode" v-if="mode == 'edit'" tooltip="Stop editing">
            <i class="fa fa-close"></i>
        </span>
         -->
    </div>
</template>

<script>
    export default {
        props: {
            id: Number,
            readOnly: {
                type: Boolean,
                default: true,
            },
        },
        data: function () {
            return {
                mode: 'view',
            }
        },
        computed: {
            block: function () {
                return this.$store.state.blocks.find(i => i.id == this.id);
            },
            cssClass: function () {
                var result = 'separator separator-block';

                if (!this.readOnly && this.mode == 'view') {
                    result += ' editable';
                }

                return result;
            },
        },
        methods: {
            editMode: function (event) {
                if (this.readOnly || this.mode == 'edit') {
                    return true;
                }

                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }
                this.mode = 'edit';
            },

            viewMode: function () {
                this.mode = 'view';
            },

            destroy: function () {
                this.$store.dispatch('deleteBlock', this.block);
            },
        },
        mounted: function () {
            if (this.block.isNewRecord) {
                this.editMode();
                delete this.block.isNewRecord;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/blocks/SeparatorBlock.vue